const defaultState = () => ({
    signedCertificate: null,
    certificateDetails: null,
    certificateLoad: true,
    generateError: false,
    showInstalledCertificate: false,
    loadCertificate: false,
    commonName: null,
    certificateType: null,
    pendingCsr: false,
    csrGeneratedAt: null
});

export default (state = defaultState(), {type, payload}) => {
    switch (type) {
        case "CONNECTOR-SETTINGS:FETCH-HTTPS-CERTIFICATE-PENDING": {
            return {
                ...state,
                commonName: null,
                signedCertificate: null,
                certificateDetails: null,
                certificateLoad: true
            }
        }
        case "CONNECTOR-SETTINGS:INSTALL-HTTPS-CERTIFICATE-PENDING": {
            return {
                ...state, loadCertificate: true
            }
        }
        case "CONNECTOR-SETTINGS:INSTALL-HTTPS-CERTIFICATE-FAILURE": {
            return {
                ...state, loadCertificate: false
            }
        }
        case "CONNECTOR-SETTINGS:INSTALL-HTTPS-CERTIFICATE-SUCCESS": {
            const {certificate, certificateType} = payload;
            return {
                ...state,
                signedCertificate: certificate,
                // NCL installs include certificateType. SaaS installs do not,
                // and their certificate details stay as they were.
                certificateDetails: certificateType ? certificate : state.certificateDetails,
                certificateType,
                showInstalledCertificate: true,
                loadCertificate: false,
                pendingCsr: false,
                csrGeneratedAt: null
            }
        }
        case "CONNECTOR-SETTINGS:REMOVE-NAVIGATE-TO-SHOW-CERTIFICATE": {
            return {
                ...state, showInstalledCertificate: false
            }
        }
        case "CONNECTOR-SETTINGS:FETCH-HTTPS-CERTIFICATE-FAILURE": {
            return {
                ...state, certificateLoad: false
            }
        }
        case "CONNECTOR-SETTINGS:FETCH-HTTPS-CERTIFICATE-SUCCESS": {
            return {
                ...state,
                commonName: payload.commonName,
                signedCertificate: payload.signedCertificate,
                certificateDetails: 'certificateDetails' in payload
                    ? payload.certificateDetails
                    : state.certificateDetails,
                certificateType: payload.certificateType,
                pendingCsr: payload.pendingCsr,
                csrGeneratedAt: payload.csrGeneratedAt,
                certificateLoad: false,
                showInstalledCertificate: false
            }
        }
        case "CONNECTOR-SETTINGS:GENERATE-HTTPS-CSR-PENDING": {
            return {...state, loadCsr: true, generateError: false}
        }
        case "CONNECTOR-SETTINGS:GENERATE-HTTPS-CSR-SUCCESS": {
            const {commonName, generatedCsr} = payload;
            return {
                ...state,
                commonName,
                generatedCsr,
                signedCertificate: null,
                certificateType: "SELF_SIGNED",
                pendingCsr: true,
                loadCsr: false
            }
        }
        case "CONNECTOR-SETTINGS:GENERATE-HTTPS-CSR-FAILURE": {
            return {...state, loadCsr: false, generateError: true}
        }
        default: {
            return state;
        }
    }
};
